<template>
    <footer class="site-footer">
        <div class="footer-content">
            <div class="footer-logo">
                <router-link to="/">
                    <img alt="PYPA Logo" src="../assets/logo/logoultrafinal9.svg">
                </router-link>
                <p class="footer-description">
                    Transformamos necesidades complejas en software simple y eficiente. Desarrollo a medida sin funciones innecesarias.
                </p>
            </div>
            
            <div class="footer-links">
                <div class="link-group">
                    <h3>Servicios</h3>
                    <ul>
                        <li><a href="#">Desarrollo Web</a></li>
                        <li><a href="#">Automatización</a></li>
                        <li><a href="#">Consultoría</a></li>
                    </ul>
                </div>
                <div class="link-group">
                    <h3>Contacto</h3>
                    <ul>
                        <li><a href="#">La Serena, Chile</a></li>
                        <li><a href="mailto:contacto@pypa.cl">contacto@pypa.cl</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <div class="copyright">
                {{ new Date().getFullYear() }} © PYPA. Todos los derechos reservados.
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterWeb'
}
</script>

<style scoped>
.site-footer {
    background-color: #000000;
    color: #9ca3af;
    padding: 60px 20px 20px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    margin-top: auto;
}

.footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 40px;
    margin-bottom: 40px;
}

.footer-logo img {
    width: 140px;
    margin-bottom: 15px;
    /* Si tu logo es negro, esto lo invierte a blanco para el fondo oscuro */
    /* filter: brightness(0) invert(1); */ 
}

.footer-description {
    font-size: 0.9rem;
    line-height: 1.5;
    max-width: 300px;
}

.footer-links {
    display: flex;
    justify-content: flex-end;
    gap: 80px;
}

.link-group h3 {
    color: white;
    font-size: 1rem;
    margin-bottom: 20px;
    font-weight: 600;
}

.link-group ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.link-group li {
    margin-bottom: 12px;
}

.link-group a {
    color: #9ca3af;
    text-decoration: none;
    transition: color 0.2s;
    font-size: 0.95rem;
}

.link-group a:hover {
    color: white;
}

.footer-bottom {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 20px;
    border-top: 1px solid #374151;
    text-align: center;
    font-size: 0.85rem;
}

@media (max-width: 768px) {
    .footer-content {
        grid-template-columns: 1fr;
        text-align: center;
    }
    
    .footer-links {
        justify-content: center;
        flex-wrap: wrap;
        gap: 40px;
    }
    
    .footer-description {
        margin: 0 auto;
    }
}
</style>